import { useQuery, type QueryResult, gql } from '@apollo/client';

export const GET_CONTRACT_BALANCES = gql`
  query ($advertiserId: String!, $advertiserNation: String!) {
    contractBalances(
      advertiserId: $advertiserId
      advertiserNation: $advertiserNation
    ) {
      contractType
    }
  }
`;

export enum ContractType {
  AD_PACK = 'AD_PACK',
  MASTER_AGREEMENT = 'MASTER_AGREEMENT',
  SEEK_CONTRACT = 'SEEK_CONTRACT',
  SUBSCRIPTION = 'SUBSCRIPTION',
}

export interface AdvertiserContract {
  contractType: ContractType;
}

interface ContractBalances {
  contractBalances: AdvertiserContract[];
}

export const useContractBalances = (
  advertiserNation: string,
  advertiserId?: string,
): QueryResult<
  ContractBalances,
  { advertiserNation: string; advertiserId: string }
> => {
  return useQuery(GET_CONTRACT_BALANCES, {
    variables: {
      advertiserId: advertiserId!,
      advertiserNation,
    },
    skip: !advertiserId,
  });
};
